import { render, staticRenderFns } from "./NflScoring.vue?vue&type=template&id=20edcf34&scoped=true"
import script from "./NflScoring.vue?vue&type=script&lang=js"
export * from "./NflScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edcf34",
  null
  
)

export default component.exports